import { Directive, App, computed, watch, ref } from 'vue';
import { AppProvider } from '/@/components/Application';
import { useUserStoreWithOut } from '/@/store/modules/user';
import { useMessage } from '/@/hooks/web/useMessage';
import ModalLogin from '/@/views/sys/login/ModalLogin.vue';

const modalHandle = ref<any>(null);
const modalMap = new WeakMap();
/**
 * v-login
 * @description: 在按钮上使用调起登录弹窗，通过autoRun修饰符可以在登录成功后自动执行绑定的方法
 * @example: v-login="{ handler?: handler, route: currentRoute }" || v-login.autoRun
 */
const loginDirective: Directive = {
  mounted(el, bind) {
    const { handler, route } = bind.value || {};

    // 创建登录弹窗
    const openModal = createOpenModal(route);
    modalMap.set(el, openModal); // 将 openModal 函数保存到 modalMap 中
    const userStore = useUserStoreWithOut();
    const isLogin = computed(() => !!userStore.getToken);
    watch(
      () => isLogin.value,
      (val) => {
        if (!val) {
          el.addEventListener('click', openModal, false);
        } else {
          el.removeEventListener('click', openModal, false);
          if (handler && typeof handler === 'function') {
            el.addEventListener('click', handler, false);
            bind.modifiers.autoRun ? handler() : null;
          }
          closeModal();
        }
      },
      {
        immediate: true,
      },
    );
  },
  beforeUnmount(el, bind) {
    const openModal = modalMap.get(el); // 从 modalMap 中获取 openModal 函数
    if (openModal) {
      // 移除 openModal 函数
      const { handler } = bind.value || {};
      el.removeEventListener('click', openModal, false);
      el.removeEventListener('click', handler, false);
      modalMap.delete(el); // 从 modalMap 中移除 openModal 函数
    }
  },
};

function createOpenModal(currentRoute) {
  return function openModal() {
    const { createInfoModal } = useMessage();
    modalHandle.value = createInfoModal({
      class: 'modal-no-btns modal-no-icon !w-[560px] linear-border rounded-lg',
      title: null,
      icon: null,
      content: () => (
        <AppProvider>
          <ModalLogin currentRoute={currentRoute} />
        </AppProvider>
      ),
      maskClosable: false,
      closable: true,
      centered: true,
      bodyStyle: {
        margin: 0,
      },
    });
  };
}
function closeModal() {
  modalHandle.value && modalHandle.value.destroy();
}

export function setupLoginDirective(app: App) {
  app.directive('login', loginDirective);
}

export default loginDirective;
